module.exports = __webpack_public_path__ + "img/locking-w.12ccecc8.png";